import { render, staticRenderFns } from "./room-participants-item.vue?vue&type=template&id=d733d39a"
import script from "./room-participants-item.vue?vue&type=script&lang=js"
export * from "./room-participants-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports